import VanillaCalendar from "@uvarov.frontend/vanilla-calendar";
import { interpret } from "xstate";
import { Dropdown, Modal } from "bootstrap";
import createBookingBarMachine from "./booking-bar-machine";

const isMobile = window.matchMedia("(max-width: 1024px)").matches;
const locationToggleDesktop = document.querySelector(".js-location-step");
const locationToggleMobile = document.querySelector(".js-location-step-mobile");
const accommodationToggleDesktop = document.querySelector(".js-accommodation-step");
const accommodationToggleMobile = document.querySelector(".js-accommodation-step-mobile");
const dateToggleDesktop = document.querySelector(".js-date-step");
const dateToggleMobile = document.querySelector(".js-date-step-mobile");
const bookingBarWrapper = document.querySelector(".js-booking-bar-animation-wrapper");
const accommodationsData =
  bookingBarWrapper && bookingBarWrapper.dataset.accommodations ? JSON.parse(bookingBarWrapper.dataset.accommodations) : {};

// format date as yyyy-mm-dd
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const localDate = `${year}-${month}-${day}`;
  return localDate;
};

/* Setter for label inside toggle button */
function setLocationLabel(label) {
  if (label) {
    const labels = document.querySelectorAll(".js-location-step-text-selected");
    labels.forEach((el) => {
      const wrapper = el.closest(".booking-bar-step-text-wrapper");
      wrapper.classList.add("--is-selected");
      // eslint-disable-next-line no-param-reassign
      el.textContent = label;
    });
  }
}

/* Setter for label inside toggle button */
function setAccommodationLabel(label) {
  if (label) {
    const labels = document.querySelectorAll(".js-accommodation-step-text-selected");
    labels.forEach((el) => {
      const wrapper = el.closest(".booking-bar-step-text-wrapper");
      wrapper.classList.add("--is-selected");
      // eslint-disable-next-line no-param-reassign
      el.textContent = label;
    });
  }
}

/* Resetter for label inside toggle button */
function resetAccommodationLabel() {
  const labels = document.querySelectorAll(".js-accommodation-step-text-selected");
  labels.forEach((el) => {
    const wrapper = el.closest(".booking-bar-step-text-wrapper");
    wrapper.classList.remove("--is-selected");
    // eslint-disable-next-line no-param-reassign
    el.textContent = "";
  });
}

/* Setter for label inside toggle button */
function setDateLabel(label) {
  if (label) {
    const labels = document.querySelectorAll(".js-date-step-text-selected");
    labels.forEach((el) => {
      const wrapper = el.closest(".booking-bar-step-text-wrapper");
      wrapper.classList.add("--is-selected");
      // eslint-disable-next-line no-param-reassign
      el.textContent = label;
    });
  }
}

function sendMetaPixelData(bookingBarService) {
  const ctx = bookingBarService.getSnapshot().context;

  var allAccommodations = ctx?.accommodationsData.filter(x => !x.id.includes("-all") && x.id != '');
  var locationCompanyId = ctx?.location.companyId;
  
  if (locationCompanyId != null) {
    var selectedAccommodations = allAccommodations.filter(x => x.location.companyId == locationCompanyId);
    var selectedAccommodation = ctx?.accommodation;
    var selectAll = selectedAccommodation?.id != null ? selectedAccommodation.id.includes("-all") : false;

    var accommodationIds = selectedAccommodation?.id == null || selectAll
      ? selectedAccommodations.map(x => x.id)
      : `${selectedAccommodation.id}`;
    var locationInformation = selectedAccommodation?.location != null
      ? selectedAccommodation
      : selectedAccommodations[0];
    
    let contentType = Array.isArray(accommodationIds) ? "destination" : "hotel";

    fbq('track', 'InitiateCheckout', {
      content_ids: accommodationIds,
      content_type: contentType,
      city: locationInformation.location.city,
      region: locationInformation.location.region,
      country: 'Slovenia'
    });
  }
}

/* Formats the date label to readable string in SI format */
function formatDateLabel(from, to) {
  if (!from || !to) return "";

  const fromLabel = new Date(from).toLocaleDateString("sl-SI", {
    day: "numeric",
    month: "numeric",
  });
  const toLabel = new Date(to).toLocaleDateString("sl-SI");

  return `${fromLabel} - ${toLabel}`;
}

/* This function initializes bootstrap dropdowns and returns a reference to them */
function initDropdowns() {
  const triggers = document.querySelectorAll(".js-booking-bar-dropdown-toggle");

  if (isMobile) {
    triggers.forEach((trigger) => {
      // Prevent auto closing on mobile
      trigger.setAttribute("data-bs-auto-close", "false");

      trigger.closest(".dropdown-parent").addEventListener("show.bs.dropdown", () => {
        triggers.forEach((t) => {
          if (t !== trigger) {
            setTimeout(() => {
              // eslint-disable-next-line no-undef
              Dropdown.getInstance(t).hide();
            }, 1);
          }
        });
      });
    });
  }

  // eslint-disable-next-line no-undef
  const dropdowns = [...triggers].map((dropdown) => new Dropdown(dropdown));

  return dropdowns;
}

/* Callback functioon for toggling next step.
   Wrapped in setTimeout to prevent event collision */
function nextStepCallback(dropdown) {
  setTimeout(() => {
    dropdown.show();
  }, 10);
}

/* After completing a step it will open the next one */
function toggleNextStep(action, value) {
  const locationStep = document.querySelector(".js-location-step");
  const accommodationStep = document.querySelector(".js-accommodation-step");
  const dateStep = document.querySelector(".js-date-step");
  // eslint-disable-next-line no-undef
  const dropdownLocation = Dropdown.getInstance(locationStep);
  // eslint-disable-next-line no-undef
  const dropdownAccommodation = Dropdown.getInstance(accommodationStep);
  // eslint-disable-next-line no-undef
  const dropdownDate = Dropdown.getInstance(dateStep);

  switch (action) {
    case "SET_LOCATION":
      locationStep.closest(".dropdown-parent").addEventListener("hidden.bs.dropdown", nextStepCallback(dropdownAccommodation));
      dropdownLocation.hide();

      locationStep.closest(".dropdown-parent").removeEventListener("hidden.bs.dropdown", nextStepCallback(dropdownAccommodation));

      if (isMobile) {
        accommodationToggleMobile.scrollIntoView({ behavior: "smooth" });
      }
      break;
    case "SET_ACCOMMODATION":
      accommodationStep.closest(".dropdown-parent").addEventListener("hidden.bs.dropdown", nextStepCallback(dropdownDate));
      dropdownAccommodation.hide();

      accommodationStep.closest(".dropdown-parent").removeEventListener("hidden.bs.dropdown", nextStepCallback(dropdownDate));
      if (isMobile) {
        dateToggleMobile.scrollIntoView({ behavior: "smooth" });
      }
      break;
    case "SET_DATE":
      if (value.date?.from && value.date?.to && !isMobile) {
        // dropdownDate.hide();
      }
      if (isMobile) {
        dateToggleMobile.scrollIntoView({ behavior: "smooth" });
      }
      break;
    default:
      break;
  }
}

/* Filters accommodations based on location selection */
function filterAccommodations(accommodations, locationData) {
  let locID = locationData.id;
  if (typeof locationData.id === "number") {
    locID = locationData.id;
  }

  accommodations.forEach((accommodation) => {
    const data = JSON.parse(accommodation.dataset.locationData);

    if (data.location?.id !== locID) {
      accommodation.classList.add("--is-hidden");
    } else {
      accommodation.classList.remove("--is-hidden");
    }

    /* Show correct "All options" card */
    if (data.showAll === true && data.location?.id === locID) {
      accommodation.classList.remove("--is-hidden");
    }
  });
}

/* Creates event handlers for mobile booking bar buttons to open dropdowns */
function initMobileDropdownTriggers() {
  if (window.matchMedia("(max-width: 1024px)").matches) {
    const classes = [".js-location-step", ".js-accommodation-step", ".js-date-step"];

    classes.forEach((dropdownClass) => {
      const dropdown = document.querySelector(dropdownClass);
      const mobileDropdownBtn = document.querySelector(`${dropdownClass}-mobile`);
      // eslint-disable-next-line no-undef
      const dropdownInstance = Dropdown.getInstance(dropdown);

      mobileDropdownBtn.addEventListener("click", () => {
        if (!mobileDropdownBtn.classList.contains("show")) {
          setTimeout(() => {
            dropdownInstance.toggle();
          }, 50);
        }
      });

      dropdown.closest(".dropdown-parent").addEventListener("shown.bs.dropdown", () => {
        mobileDropdownBtn.classList.add("show");
      });

      dropdown.closest(".dropdown-parent").addEventListener("hidden.bs.dropdown", () => {
        mobileDropdownBtn.classList.remove("show");
      });
    });
  }
}

/* Handles opening one dropdown after mobile menu is opened */
function openDefaultDropdownOnMobile() {
  const modal = document.querySelector(".js-booking-bar.modal");
  const defaultDropdown = [...document.querySelectorAll(".js-step-toggle-mobile")].filter((el) => !el.classList.contains("d-none"))[0];
  let hasBeenOpened = false;
  if (modal) {
    modal.addEventListener("shown.bs.modal", () => {
      if (!defaultDropdown.classList.contains("show") && !hasBeenOpened) {
        defaultDropdown.click();
        hasBeenOpened = true;
      }
    });
  }
}

function closeAllDropdowns(dropdowns) {
  if (dropdowns) {
    dropdowns.forEach((dropdown) => {
      dropdown.hide();
    });
  }

  const modal = document.querySelector(".js-booking-bar.modal");
  Modal.getInstance(modal)?.hide();
}

/* Main init function that coordinates the logic */
const initBookingBar = (initContext) => {
  if (
    !locationToggleDesktop ||
    !locationToggleMobile ||
    !accommodationToggleDesktop ||
    !accommodationToggleMobile ||
    !dateToggleDesktop ||
    !dateToggleMobile
  ) {
    return;
  }

  let initialContext = {};
  if (initContext) {
    initialContext = initContext;
  }

  if (bookingBarWrapper.dataset.context) {
    initialContext = JSON.parse(bookingBarWrapper.dataset.context);
  }

  if (initialContext === undefined || initialContext === null) {
    initialContext = {
      location: {
        name: null,
        id: null,
        companyId: null,
        destinationCode: null,
      },
      accommodation: {
        name: null,
        id: null,
      },
      date: {
        from: null,
        to: null,
      },
      culture: null,
      errorMessage: null,
    };
  }

  initialContext.accommodationsData = accommodationsData;

  const dropdowns = initDropdowns();
  initMobileDropdownTriggers();
  openDefaultDropdownOnMobile();

  const bookingBarMachine = createBookingBarMachine(initialContext);
  const bookingBarService = interpret(bookingBarMachine).start();

  let editingStarted = false;

  /* Calendar options */
  const calendarOptions = {
    type: window.matchMedia("(max-width:420px)").matches ? "default" : "multiple",
    date: {
      min: formatDate(new Date()),
    },
    settings: {
      range: {
        disablePast: true,
        /* disableAllDays: true, */
        disableGaps: true,
      },
      selection: {
        day: "multiple-ranged",
      },
      visibility: {
        daysOutside: false,
        theme: "light",
      },
    },
    actions: {
      clickDay(event, dates) {
        const sortedDates = dates.sort((a, b) => +new Date(a) - +new Date(b));
        const formattedDates = {
          date: {
            from: sortedDates[0] ?? null,
            to: sortedDates && sortedDates.length > 1 ? sortedDates[sortedDates.length - 1] : null,
          },
        };

        // selectedDates = formattedDates;

        switch (bookingBarService.state.value) {
          case "idle":
            bookingBarService.send("EDIT");
            editingStarted = true;

            bookingBarService.send("SET_DATE", formattedDates);
            break;
          case "editing":
            bookingBarService.send("SET_DATE", formattedDates);
            break;
          default:
            break;
        }
      },
    },
  };

  // Load preselected dates
  if (initialContext.date?.from && initialContext.date?.to) {
    calendarOptions.settings.selected = {};
    calendarOptions.settings.selected.dates = [`${initialContext.date.from}:${initialContext.date.to}`];
  }

  const calendar = new VanillaCalendar(".js-booking-bar-datepicker", calendarOptions);
  calendar.init();
  /* End of calendar */

  /* Event subscriber for state machine. Coordinate all logic related to events inside here */
  // eslint-disable-next-line no-unused-vars
  const bookingBarListener = bookingBarService.subscribe((state) => {
    // eslint-disable-next-line no-console
    // console.log(state.context, state.event.type);
    switch (state.event.type) {
      case "xstate.init":
        if (state.context?.location?.companyId) {
          setLocationLabel(state.context.location.name);
          filterAccommodations(document.querySelectorAll(".js-booking-bar-btn-selector-accommodation"), state.context.location);
        }

        if (state.context?.accommodation?.id) {
          setAccommodationLabel(state.context.accommodation.name);

          calendar.settings.range.enabled =
            accommodationsData.find((accommodation) => accommodation.id === state.context.accommodation.id).availability ?? [];
          calendar.reset();
        }

        if (state.context?.date?.from && state.context?.date?.to) {
          if (calendar.selectedDates.length) {
            setDateLabel(formatDateLabel(state.context.date.from, state.context.date.to));
          }
          // eslint-disable-next-line no-console
          //console.log(calendar.selectedDates);
          if (isMobile) {
            document.querySelector(".js-booking-bar-submit").classList.add("--is-visible");
          }
        }
        break;
      case "SET_LOCATION":
        setLocationLabel(state.event.location.name);
        resetAccommodationLabel();
        filterAccommodations(document.querySelectorAll(".js-booking-bar-btn-selector-accommodation"), state.event.location);
        toggleNextStep(state.event.type, state.context);
        break;
      case "SET_ACCOMMODATION":
        setLocationLabel(state.context.location.name);
        setAccommodationLabel(state.event.accommodation.name);
        /* calendar.settings.range.enabled =
          accommodationsData.find((accommodation) => accommodation.id === state.event.accommodation.id).availability ?? [];
        calendar.reset(); */
        toggleNextStep(state.event.type, state.context);
        break;
      case "SET_DATE":
        setDateLabel(formatDateLabel(state.event.date.from, state.event.date.to));
        toggleNextStep(state.event.type, state.context);
        if (isMobile) {
          document.querySelector(".js-booking-bar-submit").classList.add("--is-visible");
        }
        break;
      case "SUBMIT":
        closeAllDropdowns(dropdowns);
        break;
      default:
        break;
    }

    /* Error handling */
    if (state?.context?.errorMessage?.length) {
      state.context.errorMessage.forEach((error) => {
        switch (error) {
          case "location":
            locationToggleDesktop.classList.add("--has-error");
            locationToggleMobile.classList.add("--has-error");
            break;
          case "accommodation":
            accommodationToggleDesktop.classList.add("--has-error");
            accommodationToggleMobile.classList.add("--has-error");
            break;
          case "date":
            dateToggleDesktop.classList.add("--has-error");
            dateToggleMobile.classList.add("--has-error");
            break;
          default:
            break;
        }
      });
    } else {
      document.querySelectorAll(".js-booking-bar-dropdown-toggle").forEach((toggle) => {
        toggle.classList.remove("--has-error");
      });
      document.querySelectorAll(".js-booking-bar-dropdown-toggle-mobile").forEach((toggle) => {
        toggle.classList.remove("--has-error");
      });
    }
  });

  const bookingBar = document.querySelector(".js-booking-bar");
  if (!bookingBar) {
    return;
  }
  const buttonSelectors = bookingBar.querySelectorAll(".js-booking-bar-btn-selector");
  const dropdownCloseButtons = bookingBar.querySelectorAll(".js-booking-bar-dropdown-close");
  const submitButton = bookingBar.querySelector(".js-booking-bar-submit");
  // const confirmDateButton = bookingBar.querySelector(".js-booking-bar-button-confirm-date");

  // eslint-disable-next-line no-unused-vars
  const errors = null;

  /* Handle selector button events. These are buttons inside dropdowns, used to select location and accommodation. */
  buttonSelectors.forEach((buttonSelector) => {
    buttonSelector.addEventListener("click", (e) => {
      const data = JSON.parse(e.currentTarget.dataset.locationData ?? {});

      if (!editingStarted) {
        bookingBarService.send("EDIT");
        editingStarted = true;
      }

      if (data.type === "location") {
        bookingBarService.send("SET_LOCATION", {
          location: {
            name: data.name,
            id: data.id,
            companyId: data.companyId,
            destinationCode: data.destinationCode,
          },
        });
      }

      if (data.type === "accommodation") {
        bookingBarService.send("SET_ACCOMMODATION", {
          accommodation: {
            name: data.name,
            id: data.id,
            contentId: data.contentId
          },
        });
      }
    });
  });

  // confirmDateButton.addEventListener("click", () => {
  //   switch (bookingBarService.state.value) {
  //     case "idle":
  //       bookingBarService.send("EDIT");
  //       editingStarted = true;
  //
  //       bookingBarService.send("SET_DATE", selectedDates);
  //       break;
  //     case "editing":
  //       bookingBarService.send("SET_DATE", selectedDates);
  //       break;
  //     default:
  //       break;
  //   }
  // });
  const pushBookingBarSubmit = () => {
    const link = document.querySelector('.js-booking-bar-submit-anchor');

    link.addEventListener('click', (e) => {
      window.dataLayer.push({
        'event': 'CheckAvailability',
        'formLocation': 'top'
      });
    });
  };

  pushBookingBarSubmit();

  /* Send submit event and handle empty submit */
  submitButton.addEventListener("click", () => {
    bookingBarService.send("VALIDATE");
    const submit = bookingBarService.send("SUBMIT");

    if (submit.value === "idle") {
      bookingBarService.send("EMPTY_SUBMIT");
    }

    /* Meta Pixel */
    sendMetaPixelData(bookingBarService);
  });

  /* Handle close dropdown buttons. These are buttons inside the dropdowns. */
  dropdownCloseButtons.forEach((dropdownCloseButton) => {
    dropdownCloseButton.addEventListener("click", () => {
      dropdowns.forEach((dropdown) => {
        dropdown.hide();
      });
    });
  });
};

export default initBookingBar;
